import { redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";

import { ALL_PROFESSIONS } from "@/components/flows/steps/council/utils/professions";
import { getActiveSteps } from "@/hooks/use-flow-data";
import { councilStepAtom } from "@/lib/atoms/council-step-atom";
import type { UserContext } from "@/lib/interfaces/user-context";

export const COUNCIL_STEP_ID = 8;
const ENTRY_SUB_STEP = "main";

interface CouncilSubStepEntryArgs {
  context: { user: Pick<UserContext, "fluxosPendentes"> };
  params: { subStepId: string };
}

const hydrateFromResposta = (resposta: Record<string, string>): void => {
  const catalogEntry = ALL_PROFESSIONS.find((p) => p.value === resposta.profession);

  getDefaultStore().set(councilStepAtom, {
    profession: resposta.profession || null,
    professionName: resposta.professionName || catalogEntry?.label || null,
    councilNumber: resposta.councilNumber || "",
    councilAcronym: resposta.councilAcronym || catalogEntry?.council || null,
    uf: resposta.uf || "SP",
    procedures: resposta.procedures || null,
  });
};

export const enterCouncilSubStep = ({
  context,
  params,
}: CouncilSubStepEntryArgs): void => {
  const step = getActiveSteps(context.user.fluxosPendentes[0]).find(
    (s) => s.codEtapa === COUNCIL_STEP_ID,
  );

  // Etapa fora do fluxo do membro é problema do `loader` do `$stepId`, que manda para `/flows`.
  // Este `beforeLoad` roda antes dele, então sair daqui evita um redirect intermediário inútil.
  if (!step) {
    return;
  }

  const store = getDefaultStore();

  if (!store.get(councilStepAtom).profession && step.resposta?.profession) {
    hydrateFromResposta(step.resposta);
  }

  if (params.subStepId === ENTRY_SUB_STEP || store.get(councilStepAtom).profession) {
    return;
  }

  redirect({
    to: "/flows/$stepId/$subStepId",
    params: { stepId: String(COUNCIL_STEP_ID), subStepId: ENTRY_SUB_STEP },
    replace: true,
    throw: true,
  });
};
